import { BreadcrumbsContainer } from "@components/atoms/Breadcrumbs"
import { Chip } from "@components/atoms/Chip"
import { Heading } from "@components/atoms/Heading"
import { Col, Grid } from "@components/layout/Grid"
import { AnimateCard } from "@components/molecules/archive/AnimateCard"
import { useIsMobile } from "@hooks/useViewportDerived"
import { defineView } from "eddev/views"
import { VSpace } from "@components/layout/Spacer"
import { ArchiveGrid, TaxonomyContainer } from "@components/atoms/archive/Components"

export default defineView("category", (props) => {
  const isMobile = useIsMobile()

  return (
    <>
      <BreadcrumbsContainer>
        <Grid>
          <Col initial={12}>
            <ul>
              <li>
                <Chip color="white" href="/newsroom/news-archive/" icon="ARROW_LEFT" iconStyle="left">
                  Back to the news archive
                </Chip>
              </li>
            </ul>
          </Col>
        </Grid>
      </BreadcrumbsContainer>

      <TaxonomyContainer>
        <ArchiveGrid>
          {!isMobile && !env.admin && <Col initial={12} tablet={1} desktop={2} />}
          <Col initial={12} tablet={env.admin ? 12 : 10} desktop={env.admin ? 12 : 8}>
            <Heading as="h1" variant="h1">
              Category: {props.category?.name}
            </Heading>
          </Col>

          {props.category?.posts?.nodes.map((article, i) => (
            <Col initial={12} tablet={6} laptop={4} key={i} className="[&>div]:h-full">
              <AnimateCard article={article} order={i} type="news" />
            </Col>
          ))}
        </ArchiveGrid>
        <VSpace initial={8} />
      </TaxonomyContainer>
    </>
  )
})
